import { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { GlobalContext } from '../contexts/Global'
import { ForgotDetails, Home, ThankYouPage, ByePage } from '../pages'

const Router = () => {
  const {
    state: { showThankYouPage },
  } = useContext(GlobalContext)

  if (showThankYouPage) {
    return <ThankYouPage />
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/reset-password" element={<ForgotDetails />} />
      <Route path="/failed-login" element={<ByePage />} />
    </Routes>
  )
}

export default Router
